import { useState } from 'react'
import { Megaphone, X } from 'lucide-react'
import { useFeatureFlag } from '../../lib/useFeatureFlag'

const DISMISS_KEY = 'announcement-banner-dismissed-at'

export default function AnnouncementBanner({ className = '' }) {
  // Default OFF: GrowthBook unreachable/misconfigured/flag not created yet
  // must never show an unmanaged banner to every user.
  const enabled = useFeatureFlag('announcement-banner-enabled', false)
  const message = useFeatureFlag('announcement-banner-message', '')
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem(DISMISS_KEY) === 'true'
  )

  if (!enabled || !message || dismissed) return null

  return (
    <div
      className={`flex items-start gap-2 rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-sm font-medium text-sky-800 ${className}`}
    >
      <Megaphone size={18} className="mt-0.5 shrink-0" />
      <span className="flex-1">{message}</span>
      <button
        type="button"
        onClick={() => {
          localStorage.setItem(DISMISS_KEY, 'true')
          setDismissed(true)
        }}
        className="shrink-0 text-sky-500 hover:text-sky-700"
        aria-label="Dismiss"
      >
        <X size={16} />
      </button>
    </div>
  )
}
